import Model from './Model.js';

export default class Contact extends Model {
    static get defaults() {
        return {
            email: null,
            first_name: null,
            last_name: null,
        };
    }

    get fullName() {
        return `${this.first_name || ''} ${this.last_name || ''}`.trim();
    }
}
